import angular from "angular"
import "./search.component.css"

const templateUrl = require("ngtemplate-loader!html-loader!./search.component.html")
const searchIconUrl = require("ngtemplate-loader!file-loader!../../../src/static/svg/student.svg")

SearchBar.$inject = ["appRoutesService", "apiService"]
function SearchBar(appRoutesService, apiService) {
  var self = this

  self.selectedItem = null
  self.searchText = ""
  self.searchIcon = searchIconUrl

  self.results = []

  self.getMatches = function(search_text) {
    if (!search_text || search_text === "") {
      return []
    }

    var params = self.parseQuery(search_text)

    return apiService
      .getAlumnos(params)
      .then(function(data) {
        self.results = data.results
        if (data.length > 4) {
          return data.splice(0, 4)
        } else {
          return data.results
        }
      })
      .catch(function() {
        return []
      })
  }

  self.parseQuery = function(search_text) {
    //params
    var regex = /\d/
    var tokens = search_text.split(" ")
    var alumno = ""
    var cedula = ""

    tokens.forEach(function(t) {
      if (regex.test(t)) {
        cedula = t
      } else {
        alumno = alumno + " " + t
        alumno = alumno.trim()
      }
    })

    return { alumno: alumno, cedula: cedula }
  }

  self.changeView = function() {
    if (!self.selectedItem) {
      return
    }

    appRoutesService.irAFichaAlumno(self.selectedItem.id)
    self.selectedItem = null
    self.searchText = ""
    self.results = []
    self.onChangeView()
  }

  self.$onChanges = function(data) {
    if (data.searchActive) {
      if (self.searchActive) {
        self.setFocus()
      }
    }
  }

  self.setFocus = function() {
    setTimeout(function() {
      document.querySelector("#search_bar_input").focus()
    }, 0)
  }
}

angular.module("appModule").component("searchBar", {
  templateUrl: templateUrl,
  bindings: {
    searchActive: "<",
    onChangeView: "&"
  },
  controller: SearchBar
})
